import { useMemo } from 'react';
import { isResourceLoaded } from '~/_shared/types/fetchableResource/fetchableResource.helpers';
import { notNullsy } from '~/_shared/utils/typeGuards';
import { useActivePlaceSelector } from '~/store/frontendState/activeMapElements/activeMapElements.selectors';
import { usePlacesSearchResultsSelector } from '~/store/frontendState/places/places.selectors';
import { useMapSettingsPlacesSearchesSelector } from '~/store/mapSettings/places/mapSettingsPlaces.selectors';
import { useMapContext } from '../mapContext';
import { ActivePlaceIndicatorOverlay } from '../mapOverlays/activeMarkerIndicator/activePlaceIndicator.container.overlay';
import { MapPlacesManager } from './mapPlacesManager';
import { PlacesSearchHoverRectangleOverlayContainer } from './placesSearchHoverRectangleOverlay.container';
import { PlacesSearchInstance } from './placesSearchInstance';

export const PlacesOverlay = () => {
  const activePlace = useActivePlaceSelector();
  const placesSearches = useMapSettingsPlacesSearchesSelector();
  const placesSearchResults = usePlacesSearchResultsSelector();
  const { webglLayers, map } = useMapContext();

  const manager = useMemo(() => new MapPlacesManager(webglLayers), [webglLayers]);

  return (
    <>
      {placesSearches.map((search => {
        const searchResults = placesSearchResults.get(search.id);

        if (!isResourceLoaded(searchResults)) {
          return null;
        }

        return (
          <PlacesSearchInstance
            manager={manager}
            key={search.id}
            item={search}
            results={searchResults.value}
          />
        );
      })).filter(notNullsy)}
      {activePlace && (
        <ActivePlaceIndicatorOverlay
          map={map}
          activePlace={activePlace}
        />
      )}
      <PlacesSearchHoverRectangleOverlayContainer />
    </>
  );
};
